import { useMemo } from 'react';

import { ResetPasswordTypes } from 'api/forms';
import AuthStaticBlockFallback from 'components/AuthStaticBlockFallback';
import AuthLayout from 'components/Layouts/Auth';
import Meta from 'components/Meta';
import StaticBlock from 'components/StaticBlock';
import { useConfig } from 'config';
import useLayout from 'utils/layout';
import { useSearchQuery } from 'utils/location';
import { Translation } from 'utils/translations';

import ResetPasswordEmail from './Email';
import EmailSuccess from './EmailSuccess';
import ResetPasswordInit from './Init';
import Phone from './Phone';
import ResetPasswordSuccess from './ResetSuccess';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchQuery();
  const layout = useLayout();
  const staticBlockName = useConfig(
    `config.siteConfig.authForms.banners.reset-password.${layout}`,
  );

  const isPhoneResetType =
    searchParams.get('resetType') === ResetPasswordTypes.PHONE;
  const isEmailSuccess = searchParams.get('emailSuccess') === 'true';
  const isResetSuccess = searchParams.get('passwordResetSuccess') === 'true';
  const token = searchParams.get('token');

  const ResetPasswordComponent = useMemo(() => {
    const isPhoneScreen = isPhoneResetType && token;

    if (isResetSuccess) return ResetPasswordSuccess;
    if (isEmailSuccess) return EmailSuccess;
    if (isPhoneScreen) return Phone;
    if (token) return ResetPasswordEmail;
    return ResetPasswordInit;
  }, [isEmailSuccess, isPhoneResetType, token, isResetSuccess]);

  return (
    <AuthLayout title="log_in">
      <Meta title={<Translation message="title_reset_password" />} />
      <StaticBlock
        name={staticBlockName}
        fallback={<AuthStaticBlockFallback />}
      />
      <ResetPasswordComponent />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
